/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

/**
 * Stop a running preview deployment to free up resources.
 */
export type V1DeploymentsStopDeploymentRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  deploymentId: string;
};

/** @internal */
export type V1DeploymentsStopDeploymentRequestBody$Outbound = {
  deploymentId: string;
};

/** @internal */
export const V1DeploymentsStopDeploymentRequestBody$outboundSchema: z.ZodType<
  V1DeploymentsStopDeploymentRequestBody$Outbound,
  z.ZodTypeDef,
  V1DeploymentsStopDeploymentRequestBody
> = z.object({
  deploymentId: z.string(),
});

export function v1DeploymentsStopDeploymentRequestBodyToJSON(
  v1DeploymentsStopDeploymentRequestBody:
    V1DeploymentsStopDeploymentRequestBody,
): string {
  return JSON.stringify(
    V1DeploymentsStopDeploymentRequestBody$outboundSchema.parse(
      v1DeploymentsStopDeploymentRequestBody,
    ),
  );
}
